import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CommunicationService } from "src/app/services/communication.service";
import { NigeriaBanks, NigerianBank } from "../../models/nigerianBanks";
import { debounceTime, timeout, map, take } from "rxjs/operators";
import { GeneralService } from "src/app/services/general.service";
import { fromEvent, TimeoutError } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { MerchantProfileDetails } from "src/app/models/merchantProfile";
import * as localforage from "localforage";
import { MockStoreService } from "src/app/services/mock-store.service";

interface ProfileUpdate {
  nameOfDetails: "bankDetails" | "profileDetails";
  data: object;
}

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.css"]
})
export class SettingsComponent implements OnInit, AfterViewInit {
  @ViewChild("confirmBankDetailsInput", { read: ElementRef })
  confirmBankDetailsInput: ElementRef;
  updatePasswordForm: FormGroup;

  updateProfileForm: FormGroup;

  // update bank info
  public updateBankInfoForm: FormGroup;
  public nigerianBanks: Array<NigerianBank> = NigeriaBanks().data;
  accoutDetailsIsCorrect: boolean = false;
  showConfirmDetailsAnchor: boolean = true;
  merchantProfileData: MerchantProfileDetails;
  // ends here

  public businessTypes: any[] = [
    { id: 1, value: "fashion" },
    { id: 2, value: "cosmetics" },
    { id: 3, value: "jewelries" },
    { id: 4, value: "electronics" },
    { id: 5, value: "computers" },
    { id: 6, value: "furnitures" },
    { id: 7, value: "gaming" },
    { id: 8, value: "fragrances" },
    { id: 9, value: "groceries" },
    { id: 10, value: "beers, wines and spirits" }
  ];

  // profile Picture
  public profilePicture: string =
    "../../../assets/images/placeholder-img_2.jpg";
  constructor(
    private fb: FormBuilder,
    private commservice: CommunicationService,
    private generalservice: GeneralService,
    private mockstore: MockStoreService
  ) {}

  ngOnInit(): void {
    this.generalservice.fetchMerchantProfile$
      .pipe(take(1))
      .subscribe(val => this.fetchMerchantProfileData());

    // bank info form
    this.updateBankInfoForm = this.fb.group({
      password: ["", Validators.required],
      bank_id: ["", Validators.required],
      account_number: ["", Validators.required],
      account_name: ["", Validators.required]
    });
    //  uodate password form
    this.updatePasswordForm = this.fb.group({
      password: ["", Validators.required],
      new_password: ["", Validators.required]
    });

    // for Updating Profile Info Form
    this.updateProfileForm = this.fb.group({
      phone: ["", Validators.required],
      name: ["", Validators.required],
      address: ["", Validators.required],
      business_type: ["", Validators.required]
    });
  }

  ngAfterViewInit() {
    //  this observer observes the keydown event returning each keystroke as an observable
    //  which i then use
    fromEvent(this.confirmBankDetailsInput.nativeElement, "keydown")
      .pipe(
        debounceTime(350),
        map((evt: KeyboardEvent) => evt.srcElement as HTMLInputElement)
      )
      .subscribe(element => {
        if (element.value.length < 10) {
          this.showConfirmDetailsAnchor = true;
          return;
        }

        element.value = element.value.substring(0, 10);
        this.showConfirmDetailsAnchor = false;
        document.querySelector(".confirmDetails").innerHTML =
          "Confirm bank details";
      });
  }

  fetchMerchantProfileData() {
    this.commservice.getMerchantsProfileData().subscribe(
      async val => {
        this.merchantProfileData = val;
        await localforage.setItem(
          "merchantProfileData",
          this.merchantProfileData
        );
        this.fillUpFieldWithData(this.merchantProfileData);
      },
      err => {
        this.mockstore.merchantProfileDidnotLoad = true;
      }
    );
  }

  get phone() {
    return this.updateProfileForm.get("phone");
  }

  // for updating bank information
  get accountNumber() {
    return this.updateBankInfoForm.get("account_number");
  }

  get accountName() {
    return this.updateBankInfoForm.get("account_name");
  }

  get bankId() {
    return this.updateBankInfoForm.get("bank_id");
  }

  async modifyProfileDetailsInStorage(
    stuffToChange?: ProfileUpdate
  ): Promise<any> {
    try {
      const res: MerchantProfileDetails = await localforage.getItem(
        "merchantProfileData"
      );
      console.log(res);
      switch (stuffToChange.nameOfDetails) {
        case "bankDetails":
          delete res.data.account_name;
          delete res.data.account_number;
          delete res.data.bank_id;
          delete stuffToChange.data["password"];
          let data1 = { ...stuffToChange.data, ...res.data };
          res.data = data1;
          await localforage.setItem("merchantProfileData", res);
          console.log(res);
          break;
        case "profileDetails":
          delete res.data.name;
          delete res.data.phone;
          delete res.data.address;
          delete res.data.business_type;
          let data2 = { ...stuffToChange.data, ...res.data };
          res.data = data2;
          await localforage.setItem("merchantProfileData", res);
          console.log(res);
          break;
      }
    } catch (err) {
      console.log(err);
    }
  }

  fillUpFieldWithData(merchantProfileData: MerchantProfileDetails) {
    let bankDetails = {},
      profileDetails = {};
    const {
      account_name,
      account_number,
      bank_id,
      phone,
      name,
      business_type,
      address,
      picture
    } = merchantProfileData.data;
    bankDetails = { account_name, account_number, bank_id };
    this.updateBankInfoForm.patchValue(bankDetails);
    profileDetails = { phone, name, address, business_type };
    this.updateProfileForm.patchValue(profileDetails);

    //  patch the selects in the html;
    const businessOption = this.businessTypes.find(
      element => Number(element.id) == Number(business_type)
    );
    const bankSelected = this.nigerianBanks.find(
      (element: NigerianBank) => Number(element.bank_code) == Number(bank_id)
    );
    // console.log(bankSelected);
    if (bankSelected && businessOption) {
      (document.getElementById(
        "businessType"
      ) as HTMLSelectElement).selectedIndex = businessOption.id;

      (document.getElementById("bankName") as HTMLSelectElement).value =
        bankSelected.bank_code;
      this.profilePicture = picture;
    }

    return;
  }

  submitBankInfoForm(form: FormGroup, event) {
    if (!window.navigator.onLine) {
      this.generalservice.warningNotification(
        "You do not have an active internet connection!"
      );
      return;
    }
    // console.log(event.srcElement.querySelector(".btn-primary"));
    const btn = (event.srcElement as HTMLFormElement).querySelector(
      ".btn-primary"
    ) as HTMLButtonElement;
    // console.log((event.srcElement as HTMLFormElement).closest('.bankInfoToggle'));
    btn.disabled = true;
    btn.innerText = "Modifying...";
    let formToSubmit = { ...form.value };
    this.commservice
      .updateBankInfo(formToSubmit)
      .pipe(timeout(60000))
      .subscribe(
        val => {
          const { message } = val;
          btn.disabled = false;
          btn.innerText = " Change bank information";
          let stuffToModify: ProfileUpdate = {
            nameOfDetails: "bankDetails",
            data: { ...form.value }
          };
          this.modifyProfileDetailsInStorage(stuffToModify);
          form.reset();
          (document.querySelector(
            ".bankInfoToggle"
          ) as HTMLAnchorElement).click();
          this.generalservice.successNotification(message);
        },
        err => {
          if (err instanceof TimeoutError) {
            this.accountName.reset();
            this.accountNumber.reset();
            this.generalservice.errorNotification(
              "It seems you have poor internet connection! Please check it and try again"
            );
            btn.disabled = false;
            btn.innerText = "CHANGE BANK INFORMATION";
          } else if (
            err instanceof HttpErrorResponse &&
            err.status.toString().includes("4")
          ) {
            const { message } = err.error;
            this.generalservice.errorNotification(message);
            btn.disabled = false;
            btn.innerText = "CHANGE BANK INFORMATION";
          } else {
            const { message } = err.error;
            this.generalservice.errorNotification(message);
            btn.disabled = false;
            btn.innerText = "CHANGE BANK INFORMATION";
            form.reset();
          }
        }
      );
  }

  //  this function fetches the bank details that was entered
  getFectchAccountDetails(anchor: HTMLAnchorElement) {
    if (!window.navigator.onLine) {
      this.generalservice.warningNotification(
        "Please check your internet connection"
      );
      return;
    }
    let obj = {
      account_number: this.accountNumber.value,
      bank_code: this.bankId.value
    };
    this.commservice
      .getAccountDetails(obj)
      .pipe(timeout(50000))
      .subscribe(
        val => {
          try {
            const { account_name } = val.data;
            this.accountName.patchValue(account_name);
            anchor.innerText = "Confirmed";
            anchor.style.pointerEvents = "auto";
            this.accoutDetailsIsCorrect = true;
            this.showConfirmDetailsAnchor = false;
            setTimeout(() => {
              this.accoutDetailsIsCorrect = false;
              this.showConfirmDetailsAnchor = true;
            }, 2500);
          } catch (err) {
            // const { message } = val;
            this.generalservice.errorNotification(
              "Bank account details seems to be wrong. Please check and try again"
            );
            anchor.style.pointerEvents = "auto";
            anchor.innerText = "Confirm bank details";
          }
        },
        err => {
          anchor.style.pointerEvents = "auto";
          this.generalservice.errorNotification(
            "Could not confirm you bank details. Please check that you entered the right details"
          );
          anchor.innerText = "Confirm bank details";
        }
      );
  }

  //  this function will confirm the bank details being entered
  confirmBankDetails(event: Event) {
    let anchor = event.srcElement as HTMLAnchorElement;

    if (this.accountNumber.value.length < 10) {
      this.generalservice.warningNotification(
        "The account number has to be 10 digits"
      );
      return;
    }
    if (!this.bankId.value) {
      this.generalservice.warningNotification(
        "Please select a bank from the drop down list"
      );
      return;
    }
    anchor.style.pointerEvents = "none";
    anchor.innerText = "Confirming....";
    this.getFectchAccountDetails(anchor);
  }
  //  ends here

  //  for updating password

  submitPassword(form: FormGroup, event: Event) {
    const btn = (event.srcElement as HTMLFormElement).querySelector(
      ".btn-primary"
    ) as HTMLButtonElement;
    btn.disabled = true;
    btn.innerText = "CHANGING PASSWORD....";
    const formToSubmit = { ...form.value };
    this.commservice
      .updatePassword(formToSubmit)
      .pipe(timeout(60000))
      .subscribe(
        val => {
          const { message } = val;
          btn.disabled = false;
          btn.innerText = "CHANGE PASSWORD";
          this.generalservice.successNotification(message);
          form.reset();
          (document.querySelector(
            ".changePassword"
          ) as HTMLAnchorElement).click();
        },
        err => {
          if (err instanceof TimeoutError) {
            form.reset();
            this.generalservice.errorNotification(
              "It seems you have poor internet connection! Please check it and try again"
            );
            btn.disabled = false;
            btn.innerText = "CHANGE PASSWORD";
          } else if (
            err instanceof HttpErrorResponse &&
            err.status.toString().includes("4")
          ) {
            const { message } = err.error;
            this.generalservice.errorNotification(message);
            btn.disabled = false;
            btn.innerText = "CHANGE PASSWORD";
            form.reset();
          } else {
            const { message } = err.error;
            this.generalservice.errorNotification(message);
            btn.disabled = false;
            btn.innerText = "CHANGE PASSWORD";
            form.reset();
          }
        }
      );
  }

  //  updating Profile info
  submitProfileForm(form: FormGroup, event) {
    if (!window.navigator.onLine) {
      this.generalservice.warningNotification(
        "You do not have an active internet connection!"
      );
      return;
    }
    // console.log(event.srcElement.querySelector(".btn-primary"));
    const btn = (event.srcElement as HTMLFormElement).querySelector(
      ".btn-primary"
    ) as HTMLButtonElement;
    // console.log((event.srcElement as HTMLFormElement).closest('.bankInfoToggle'));
    btn.disabled = true;
    btn.innerText = "Modifying...";
    let formToSubmit = { ...form.value };
    this.commservice
      .updateProfileData(formToSubmit)
      .pipe(timeout(60000))
      .subscribe(
        val => {
          const { message } = val;
          btn.disabled = false;
          btn.innerText = "CHANGE PROFILE INFO";
          let stuffToModify: ProfileUpdate = {
            nameOfDetails: "profileDetails",
            data: { ...form.value }
          };
          this.modifyProfileDetailsInStorage(stuffToModify);
          form.reset();
          (document.querySelector(".profileInfo") as HTMLAnchorElement).click();
          this.generalservice.successNotification(message);
        },
        err => {
          if (err instanceof TimeoutError) {
            this.accountName.reset();
            this.accountNumber.reset();
            this.generalservice.errorNotification(
              "It seems you have poor internet connection! Please check it and try again"
            );
            btn.disabled = false;
            btn.innerText = "CHANGE PROFILE INFO";
          } else if (
            err instanceof HttpErrorResponse &&
            err.status.toString().includes("4")
          ) {
            const { message } = err.error;
            this.generalservice.errorNotification(message);
            btn.disabled = false;
            btn.innerText = "CHANGE BANK INFORMATION";
          } else {
            const { message } = err.error;
            this.generalservice.errorNotification(message);
            btn.disabled = false;
            btn.innerText = "CHANGE BANK INFORMATION";
            form.reset();
          }
        }
      );
  }

  // changes pictures
  insertPictureFromLocalDisk(event) {
    // check the file the user is trying to upload is
    // more than 2.5mb. If it is, tell d user;
    if (event.target.files[0].size > 2000000) {
      this.generalservice.warningNotification(
        "Please upload pictures less than 2.0MB"
      );
    }

    // save the picture in a formData
    const picture = new FormData();
    const pictureFile: File = event.target.files[0];
    picture.append("picture", pictureFile);

    // upload picture
    this.uploadPicture(picture);
    // console.log(event.target.files);
    let reader: FileReader;
    if (FileReader) {
      // check if the filereader api is supported by browser

      reader = new FileReader();
      reader.onload = event => {
        this.profilePicture = `${event.target["result"]}`;
      };
      reader.readAsDataURL(event.target.files[0]);
      // this.controlAnimation();
    }
  }

  // trigger for changing picture
  trigger() {
    (document.getElementById("inputFile") as HTMLInputElement).click();
  }

  openEditingTab(whatToOpen?: string) {
    (document.getElementById("product-tab-desc") as HTMLAnchorElement).click();
    switch (whatToOpen) {
      case ".profileInfo":
        (document.querySelector(whatToOpen) as HTMLAnchorElement).click();
        break;
      case ".bankInfoToggle":
        (document.querySelector(whatToOpen) as HTMLAnchorElement).click();
        break;
    }
    // (document.getElementById("product-tab-desc") as HTMLAnchorElement).click();
  }

  uploadPicture(formData: FormData) {
    debugger;
    this.commservice.updateProfilePicture(formData).subscribe(
      val => {
        const { message } = val;
        this.generalservice.successNotification(message);
      },
      err => {
        this.generalservice.errorNotification("Failed to upload picture");
      }
    );
  }
}
